import script from "./Board.vue?vue&type=script&setup=true&lang=js"
export * from "./Board.vue?vue&type=script&setup=true&lang=js"

import "./Board.vue?vue&type=style&index=0&id=32c90061&lang=scss&scoped=true"

import exportComponent from "D:\\project\\new_fd_yun\\website-dev-En\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32c90061"]])

export default __exports__